import { useState } from "react";
import { formatLastSaved } from "../hooks/useAutoSave.js";

function SavedStatusIndicator({
  isSaving,
  lastSaved,
  saveError,
  onClearSavedData,
}) {
  const [showConfirm, setShowConfirm] = useState(false);

  const getStatusText = () => {
    if (saveError) {
      return { text: saveError, className: "error" };
    }
    if (isSaving) {
      return { text: "Saving...", className: "saving" };
    }
    if (lastSaved) {
      return {
        text: `Saved ${formatLastSaved(lastSaved)}`,
        className: "saved",
      };
    }
    return { text: "Ready to save", className: "ready" };
  };

  const status = getStatusText();

  const getStatusIcon = (s) => {
    if (!s) return "fa-info-circle";
    switch (s.className) {
      case "error":
        return "fa-exclamation-triangle";
      case "saving":
        return "fa-spinner fa-spin";
      case "saved":
        return "fa-check-circle";
      case "ready":
      default:
        return "fa-info-circle";
    }
  };

  return (
    <div className="saved-status-indicator">
      <div className={`status-text ${status.className}`}>
        <i className={`fas ${getStatusIcon(status)}`}></i>
        <span>{status.text}</span>
      </div>

      {lastSaved && (
        <button
          type="button"
          className="clear-saved-btn"
          onClick={() => setShowConfirm(true)}
          title="Clear saved data and start fresh"
        >
          <i className="fas fa-trash"></i>
          Clear / Start Fresh
        </button>
      )}

      {showConfirm && (
        <div className="clear-confirm-dialog">
          <p>
            Are you sure you want to clear all saved data? This cannot be
            undone.
          </p>
          <div className="confirm-buttons">
            <button
              type="button"
              className="confirm-yes"
              onClick={() => {
                if (onClearSavedData) {
                  onClearSavedData();
                }
                setShowConfirm(false);
              }}
            >
              Clear / Start Fresh
            </button>
            <button
              type="button"
              className="confirm-no"
              onClick={() => setShowConfirm(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SavedStatusIndicator;
